// extracted by mini-css-extract-plugin
export default {"container":"Survey_container__GLd6h","button":"Survey_button__caFgS","title":"Survey_title__-EY8S","circularProgress":"Survey_circularProgress__t0wdJ"};